/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sample: NonNullable<unknown> }} Gc_Home_Preview_AltInputs */

const en_gc_home_preview_alt = /** @type {(inputs: Gc_Home_Preview_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Official GridCraft screenshot: ${i?.sample}`)
};

const zh_gc_home_preview_alt = /** @type {(inputs: Gc_Home_Preview_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`GridCraft 官方截图：${i?.sample}`)
};

/**
* | output |
* | --- |
* | "Official GridCraft screenshot: {sample}" |
*
* @param {Gc_Home_Preview_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_preview_alt = /** @type {((inputs: Gc_Home_Preview_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Preview_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_preview_alt(inputs)
	return zh_gc_home_preview_alt(inputs)
});
export { gc_home_preview_alt as "gc.home.preview_alt" }